export default __webpack_public_path__ + "static/spark-23c70d91d371684ee058a42e81a2c45a.png";